import {Api} from '@/api/Api';
import {deserialize} from '@/api/Deserializer';
import {ClientSchema, type Client} from '@/models/Client';

export default class ClientAPI extends Api {
  branding(subdomain: string): Promise<Client> {
    return this.get({
      url: `clients/${encodeURIComponent(subdomain)}/branding`,
    })
      .then((res) => this.processResponse(res))
      .then((res) => deserialize<Client>(res, ClientSchema) as Client);
  }
}
